/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { AutoTestStepBaseInputAsJSON } from './AutoTestStepBaseInputAsJSON';
import { IOTestExtra } from './IOTestExtra';
const IOTestInputAsJSONParser = 
/* #__PURE__ */ /* #__PURE__ */ codec.intersect(IOTestExtra, AutoTestStepBaseInputAsJSON);
export class IOTestInputAsJSON extends AutoTestStepBaseInputAsJSON {
    static decode(input) {
        return IOTestInputAsJSONParser.decode(input).map(res => new IOTestInputAsJSON(res));
    }
    static unsafeDecode(input) {
        return IOTestInputAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return IOTestInputAsJSONParser.encode(data);
    }
    static schema() {
        return IOTestInputAsJSONParser.schema();
    }
}
